class User {

  static factory($resource, $log, config) {
    return $resource(
      config.userResourcePath + '/:id',
      { id: '@id' },
      {
        create: {
          method: 'POST'
        },
        get: {
          method: 'GET'
        }
      }
    )
  }
}

User.factory.$inject = ['$resource', '$log', 'config']

export default User
